var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreparation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 145,
    viewBox: "0 0 112 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.0062 5.2455L80.0559 5.27017C83.7081 6.88607 87.1366 9.00771 90.1056 11.6598C100.404 20.8371 106.702 34.2947 109.708 47.888C115.348 73.3599 110.59 101.435 94.8261 122.306C91.882 126.191 88.5528 129.793 84.913 133.05C68.5528 147.667 43.4472 147.667 27.0869 133.05C23.4472 129.793 20.1056 126.191 17.1739 122.306C1.40993 101.435 -3.34783 73.3599 2.29192 47.888C5.29813 34.2947 11.5963 20.8371 21.8944 11.6598C24.8758 9.00771 28.2919 6.89841 31.9441 5.27017L31.9938 5.2455C47.2236 -1.7485 64.7764 -1.7485 80.0062 5.2455Z",
    fill: "url(#paint0_radial_467_119582)",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6461 92.8635C48.6461 92.8635 48.6213 92.8635 48.6088 92.8635C44.7703 92.8018 40.4225 92.7278 36.4473 90.9145C32.5343 89.126 28.5716 84.8457 29.1181 79.6649C29.615 74.8789 33.4163 71.9185 36.7579 69.3034C37.3542 68.8347 37.9504 68.366 38.5219 67.8972C45.5157 62.0997 49.3914 52.54 48.4101 43.5601C47.379 34.2101 40.9442 25.8715 32.7579 23.2935C24.174 20.5798 13.8511 24.9711 10.6709 32.6805C10.1616 33.914 8.74547 34.4938 7.51566 34.0004C6.27342 33.4946 5.68957 32.0884 6.18647 30.8673C10.3355 20.8018 23.1803 15.2264 34.2237 18.7172C44.348 21.912 51.9877 31.6937 53.23 43.0544C54.4101 53.7612 49.9629 64.7025 41.6275 71.6101C41.0312 72.1035 40.3977 72.6093 39.7517 73.1027C36.907 75.323 34.2237 77.4323 33.938 80.183C33.6523 82.8844 36.0126 85.4378 38.4722 86.5726C41.5157 87.9665 45.1678 88.0281 48.6834 88.0898C50.025 88.1145 51.0933 89.2123 51.0685 90.5322C51.0436 91.852 49.9629 92.9005 48.6461 92.9005V92.8635Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7813 92.8635C62.7813 92.8635 62.8062 92.8635 62.8186 92.8635C66.6571 92.8018 71.0049 92.7278 74.9801 90.9145C78.8931 89.126 82.8559 84.8457 82.3093 79.6649C81.8124 74.8789 78.0111 71.9185 74.6695 69.3034C74.0733 68.8347 73.477 68.366 72.9056 67.8972C65.9118 62.0997 62.036 52.54 63.0174 43.5601C64.0484 34.2101 70.4832 25.8715 78.6695 23.2935C87.2534 20.5798 97.5764 24.9711 100.756 32.6805C101.266 33.914 102.682 34.4938 103.912 34.0004C105.154 33.4946 105.738 32.0884 105.241 30.8673C101.092 20.8018 88.2472 15.2264 77.2037 18.7172C67.0795 21.912 59.4397 31.6937 58.1975 43.0544C57.0174 53.7612 61.4646 64.7025 69.8 71.6101C70.3962 72.1035 71.0298 72.6093 71.6757 73.1027C74.5205 75.323 77.2037 77.4323 77.4894 80.183C77.7751 82.8844 75.4149 85.4378 72.9552 86.5726C69.9118 87.9665 66.2596 88.0281 62.7441 88.0898C61.4024 88.1145 60.3341 89.2123 60.359 90.5322C60.3838 91.852 61.4646 92.9005 62.7813 92.9005V92.8635Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0096 53.0039C76.1436 53.0039 73.0096 49.8699 73.0096 46.0039C73.0096 42.1379 76.1436 39.0039 80.0096 39.0039C83.8756 39.0039 87.0096 42.1379 87.0096 46.0039C87.0096 49.8699 83.8756 53.0039 80.0096 53.0039Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0096 53.0039C26.1436 53.0039 23.0096 49.8699 23.0096 46.0039C23.0096 42.1379 26.1436 39.0039 30.0096 39.0039C33.8756 39.0039 37.0096 42.1379 37.0096 46.0039C37.0096 49.8699 33.8756 53.0039 30.0096 53.0039Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7738 130.102C39.8732 130.102 24.8173 119.802 19.1651 105.049C18.8546 104.235 19.0161 103.31 19.5875 102.632C20.1589 101.965 21.0533 101.657 21.9229 101.83C44.1341 106.32 67.5999 106.172 89.749 101.398C90.6061 101.213 91.513 101.509 92.0844 102.163C92.6682 102.829 92.8421 103.742 92.5316 104.568C87.1279 119.259 71.7614 129.991 56.0223 130.089H55.7987L55.7738 130.102ZM25.6123 107.43C31.5502 117.989 43.5751 125.291 55.7738 125.291H55.9726C68.2583 125.217 80.2583 117.754 86.0968 107.035C75.8111 108.947 65.3018 109.922 54.78 109.922C44.9912 109.922 35.2024 109.083 25.6123 107.43Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0096,
    cy: 104.004,
    r: 4,
    fill: "#33B1FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.0096,
    cy: 81.0039,
    r: 4,
    fill: "#33B1FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.0096,
    cy: 46.0039,
    r: 4,
    fill: "#33B1FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.0096,
    cy: 81.0039,
    r: 4,
    fill: "#33B1FF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.0096,
    cy: 46.0039,
    r: 4,
    fill: "#33B1FF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.0096,
    cy: 104.004,
    r: 4,
    fill: "#33B1FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_467_119582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56 69.079) rotate(90) scale(72.1604 56.1103)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F62FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F62FE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreparation);
export default __webpack_public_path__ + "static/media/preparation.d7035f166f8f0c57cc3ec31316ef8026.svg";
export { ForwardRef as ReactComponent };